import { FontStyle } from "jspdf-autotable";
import { ReportPrinter } from "./ReportPrinter";

export async function autoPage2(printer: ReportPrinter) {
  printer.autoTable({
    margin: {
      horizontal: printer.pageMarginX * 2,
      vertical: printer.pageMarginY * 1.5,
    },
    styles: {
      halign: "left",
      valign: "middle",
      font: "Roboto",
      fontStyle: "slab-light" as FontStyle,
      fontSize: 9,
      cellPadding: 4,
      lineColor: [0, 0, 0],
      lineWidth: 0.25,
    },
    headStyles: {
      halign: "center",
      font: "Roboto",
      fontStyle: "slab-normal" as FontStyle,
      fontSize: 8,
    },
    columnStyles: {
      0: { cellWidth: 105 },
      1: {},
      2: { cellWidth: 50 },
      3: { cellWidth: 60 },
      4: { cellWidth: 40 },
      5: { cellWidth: 105 },
      6: {},
      7: { cellWidth: 50 },
      8: { cellWidth: 60 },
      9: { cellWidth: 40 },
    },
    columns: [
      "Фамилия и № на водача\nизпълнител на превоза",
      "Маршрут\n(от - до)",
      "Тръгване\n(ч. мин.)",
      "Пристигане\n(ч. мин.)",
      "Заверка",
      "Фамилия и № на водача\nизпълнител на превоза",
      "Маршрут\n(от - до)",
      "Тръгване\n(ч. мин.)",
      "Пристигане\n(ч. мин.)",
      "Заверка",
    ],
    body: [...new Array(26)].map(() => [
      " ",
      " ",
      " ",
      " ",
      " ",
      " ",
      " ",
      " ",
      " ",
      " ",
    ]),
  });

  printer.printSpace(30);
  printer.doc.setLineDashPattern([1, 3], 0);
  const tsize = printer.printText(
    "Бележки на контролните органи:",
    printer.pageMarginX * 2
  );
  printer.doc.line(
    printer.pageMarginX * 2 + tsize.width + 5,
    printer.currentPageY - tsize.height,
    printer.printableWidth,
    printer.currentPageY - tsize.height
  );
  printer.withFont(
    () => {
      printer.doc.text(
        "(подпис и печат на контролните органи)",
        printer.printableWidth,
        printer.currentPageY - tsize.height / 2,
        { align: "right" }
      );
    },
    "slab-light",
    8
  );
}
